import { useTranslation } from 'react-i18next';
import { verifyAttrs } from '@/shared/verify/core/contract';

interface UnavailableExperienceAlternativesProps {
  /** Same-day times (HH:mm) where this experience is bookable. */
  times: string[];
  /** Switch the booking to the chosen time and select this experience. */
  onPick: (time: string) => void;
}

/**
 * Chip row shown on a time-unavailable experience card: the other times that
 * day where the experience IS bookable. Tapping a chip recovers from the
 * dead-end without leaving the experience step.
 */
export function UnavailableExperienceAlternatives({
  times,
  onPick,
}: UnavailableExperienceAlternativesProps) {
  const { t } = useTranslation('booking');
  if (times.length === 0) return null;

  return (
    <div
      className="mt-3"
      {...verifyAttrs('UnavailableExperienceAlternatives', { timeCount: times.length })}
    >
      <p className="text-xs text-foreground/50 mb-1.5">
        {t('EXPERIENCE_AVAILABLE_AT_OTHER_TIMES')}
      </p>
      <div className="flex flex-wrap gap-2">
        {times.map((time) => (
          <button
            key={time}
            type="button"
            data-testid={`switch-time-${time}`}
            className="px-3 py-1.5 rounded-lg border border-brand/40 text-sm text-foreground hover:bg-brand/10 transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              onPick(time);
            }}
          >
            {time}
          </button>
        ))}
      </div>
    </div>
  );
}
